export default __webpack_public_path__ + "static/media/Grayscale.0094fb2f.png";